import { useCallback } from 'react'
import camelcaseKeys from 'camelcase-keys'
import { ENDPOINTS } from 'apps/placeme/src/constants/endpoints'
import { getAxios } from '../utils'

export interface GeocodedLocation {
  formattedAddress: string
  placeId: string
  geometry: {
    location: {
      lat: number
      lng: number
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useGeocoder() {
  const reverseGeocode = useCallback(
    async (lat: number | string, lng: number | string) => {
      const axiosInstance = await getAxios()
      const res = await axiosInstance.post(ENDPOINTS.GEOCODER, {
        lat,
        lng,
      })

      if (!res?.data?.length) {
        return undefined
      }

      return camelcaseKeys(res.data, {
        deep: true,
      })
    }, [getAxios],
  )

  const geocode = useCallback(async (address: string) => {
    const axiosInstance = await getAxios()
    const res = await axiosInstance.post(ENDPOINTS.GEOCODER, {
      address,
    })

    if (!res?.data?.length) {
      return undefined
    }

    return camelcaseKeys(res.data[0], {
      deep: true,
    })
  }, [getAxios])

  return {
    reverseGeocode,
    geocode,
  }
}

export default useGeocoder
